import {useSignal, useSignals} from '@preact/signals-react/runtime'
import React, {createContext, useCallback, useContext, useMemo} from 'react'
import {useAuth} from '../../components/authentication/AuthProvider'
import {useAppConfig} from '../app/AppContext'
import {useAppConfigurationCRUD} from '../app/query-keys/AppQueryManager'
import {
    getStorageCurrentSelectedHospitalId,
    setStorageCurrentSelectedHospitalId,
} from './HospitalEvent'

export const UserHospitalContext = createContext({})

const UserHospitalProvider = React.memo(({children}) => {
    useSignals()

    //#region User App Configuration
    const {user} = useAuth()
    const {hospitalsBelong} = useAppConfig()
    const {mutate: mutateAppConfigurationCRUD} = useAppConfigurationCRUD(
        user?.id,
    )
    //#endregion

    //#region Initial Hospital

    const initialCurrentHospital = useMemo(() => {
        if (getStorageCurrentSelectedHospitalId()) {
            const storageHospital = hospitalsBelong?.find(
                item => item?.id === getStorageCurrentSelectedHospitalId(),
            )

            if (storageHospital) {
                return storageHospital
            }
        }

        return hospitalsBelong?.length > 0 ? hospitalsBelong[0] : {}
    }, [hospitalsBelong])
    // //#endregion

    // //#region Hospital Signal Management
    const currentHospital = useSignal({})

    const handleChangeHospital = useCallback(newHospital => {
        if (!newHospital?.id) {
            return
        }

        currentHospital.value = newHospital

        setStorageCurrentSelectedHospitalId(newHospital?.id)
    }, [])

    const handleUpdateHospitals = useCallback(newUpdatedHospital => {
        if (!newUpdatedHospital?.id) {
            return
        }

        if (currentHospital?.value?.id === newUpdatedHospital?.id) {
            currentHospital.value = newUpdatedHospital
        }

        if (hospitalsBelong?.length > 0) {
            const updatedHospitals = hospitalsBelong.map(hospital => {
                if (hospital?.id === newUpdatedHospital?.id) {
                    return newUpdatedHospital
                }

                return hospital
            })

            mutateAppConfigurationCRUD('hospitalsBelong', updatedHospitals)
        }
    }, [])

    useMemo(() => {
        currentHospital.value = initialCurrentHospital
    }, [initialCurrentHospital])
    //#endregion

    // TODO - Implement Hospital Signal Management {EventListener}

    return (
        <UserHospitalContext.Provider
            value={{
                currentHospital: currentHospital?.value,

                onChangeHospital: handleChangeHospital,
                updateHospitals: handleUpdateHospitals,
            }}>
            {children}
        </UserHospitalContext.Provider>
    )
})

export const useUserHospital = () => useContext(UserHospitalContext)

export default UserHospitalProvider
